import { IconButton, Table, TableBody, TableHead, TableRow } from '@mui/material';
import DocumentScannerIcon from '@mui/icons-material/DocumentScanner';
import EditIcon from '@mui/icons-material/Edit';
import {
  GeneralTableBox,
  HeadTableCell,
  RowTableCell,
  NoDataSkeleton,
} from '../../../common/components';

const UpdateDebtDataTable = ({ 
  data, 
  isLoading, 
  onEdit, 
  onViewDetails, 
  LoadingComponent 
}) => {
  return (
    <GeneralTableBox>
      <Table aria-label="update debt table">
        <TableHead>
          <TableRow>
            <HeadTableCell wmd="15%" wxs="15%">
              Orden
            </HeadTableCell>
            <HeadTableCell wmd="25%" wxs="25%">
              Suscriptores
            </HeadTableCell>
            <HeadTableCell wmd="15%" wxs="15%">
              Cuotas con Deuda
            </HeadTableCell>
            <HeadTableCell wmd="15%" wxs="15%">
              Ajustes con Deuda
            </HeadTableCell>
            <HeadTableCell wmd="10%" wxs="10%">
              Total
            </HeadTableCell>
            <HeadTableCell wmd="10%" wxs="10%">
              Editar
            </HeadTableCell>
            <HeadTableCell wmd="10%" wxs="10%">
              Ver
            </HeadTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {isLoading ? (
            <LoadingComponent />
          ) : data && data.length > 0 ? (
            data.map((item, index) => (
              <TableRow key={index}>
                <RowTableCell>{item.header.contract_number}</RowTableCell>
                <RowTableCell>{item.header.subscriber}</RowTableCell>
                <RowTableCell>{item.header.debt_installment}</RowTableCell>
                <RowTableCell>{item.header.adequacy_installment}</RowTableCell>
                <RowTableCell>{item.header.total}</RowTableCell>
                <RowTableCell>
                  <IconButton 
                    onClick={() => onEdit(item)}
                    sx={{
                      '&:hover': {
                        transform: 'scale(1.1)',
                        backgroundColor: 'rgba(94, 137, 79, 0.08)',
                      },
                    }}
                  >
                    <EditIcon sx={{ color: '#5e894f' }} />
                  </IconButton>
                </RowTableCell>
                <RowTableCell>
                  <IconButton 
                    onClick={() => onViewDetails(item)}
                    sx={{
                      '&:hover': {
                        transform: 'scale(1.1)',
                        backgroundColor: 'rgba(94, 137, 79, 0.08)',
                      },
                    }}
                  >
                    <DocumentScannerIcon sx={{ color: '#5e894f' }} />
                  </IconButton>
                </RowTableCell>
              </TableRow>
            ))
          ) : (
            <NoDataSkeleton 
              colSpan={7} 
              message="No se encontraron registros de deuda" 
            />
          )}
        </TableBody>
      </Table>
    </GeneralTableBox>
  );
};

export default UpdateDebtDataTable;